import { cx } from '../utils/format.js'

/**
 * Standard surface used throughout the app. Soft warm shadow + 1px
 * border at 60% opacity so cards sit gently on the tinted background
 * without the harsh outline of a generic dashboard.
 */
export function Card({ children, className = '' }) {
  return (
    <div className={cx(
      'bg-white rounded-2xl shadow-card border border-sand-200/60 p-4 sm:p-5',
      className,
    )}>
      {children}
    </div>
  )
}

/**
 * Display-font heading with optional subtitle and right-aligned slot.
 */
export function CardHeader({ title, subtitle, right, icon = null }) {
  return (
    <div className="flex items-start justify-between gap-3 mb-3">
      <div className="flex items-start gap-3 min-w-0">
        {icon && (
          <div className="shrink-0 w-9 h-9 rounded-xl bg-wantok-50 text-wantok-700 flex items-center justify-center">
            {icon}
          </div>
        )}
        <div className="min-w-0">
          <div className="font-display font-semibold text-slate-900 tracking-tight">{title}</div>
          {subtitle && <div className="text-xs text-slate-500 mt-0.5 leading-relaxed">{subtitle}</div>}
        </div>
      </div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  )
}
